export default __webpack_public_path__ + "media/storefront/img/bids.com-2d0ab88e27ed102d7c1c303eeb89b36c.svg";